import {StripePrice} from "@/stripe/interfaces";

/**
 * Stripe price service.
 */
const StripePriceService = () => {
    return {
        /**
         * Get the lowest price from a list of prices.
         */
        lowestPrice: (prices?: StripePrice[]): StripePrice | null => {
            if (!prices || prices.length === 0) {
                return null;
            }

            return prices.find(price => {
                if (price?.price) {
                    return parseInt(price.price.replace(",", "")) === Math.min(...prices.map(price => parseInt(price?.price?.replace(",", "") || "")));
                }

                return false;
            }) || prices[0];
        },
        /**
         * Get the featured price from a list of prices.
         * It first looks for the default price, if not found, it returns the lowest price.
         *
         * @param prices
         */
        featuredPrice(prices?: StripePrice[]): StripePrice | null {
            if (!prices || prices.length === 0) {
                return null;
            }

            return prices.find(price => price.is_default) || this.lowestPrice(prices);
        },
        /**
         * Make a human readable price.
         */
        formatPrice: (priceInfo: StripePrice): string => {
            const {price, recurring} = priceInfo;
            const intervalMapping = {
                "day": "jour",
                "week": "semaine",
                "month": "mois",
                "year": "an"
            };

            const interval = intervalMapping[recurring.interval] || recurring.interval;
            const intervalCount = recurring.interval_count > 1 ? recurring.interval_count : '';

            if (price) {
                const priceFormatted = `${parseFloat(price.replace(",", "")).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                })}`;

                return `${priceFormatted}/${intervalCount ? `${intervalCount} ` : ''}${interval}`;
            }

            return '';
        }
    };
};

export default StripePriceService();
